import cx from 'classnames';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

const Button = ({
  label,
  href,
  item = null,
  type = 'button',
  openLinkInNewTab,
  forceExternal = false,
  invert = false,
  xsmall = false,
  small = false,
  large = false,
  circle = false,
  primary = false,
  secondary = false,
  link = false,
  className,
  children,
  ...rest
}) => {
  const classes = cx(
    'cop30-button',
    { invert, xsmall, small, large, primary, secondary, link, circle },
    className,
  );
  const content = children || label;

  if (href || item) {
    return forceExternal ? (
      <a
        href={href}
        target={openLinkInNewTab ? '_blank' : null}
        rel={openLinkInNewTab ? 'noreferrer' : null}
        className={classes}
        {...rest}
      >
        {content}
      </a>
    ) : (
      <UniversalLink
        href={href}
        item={item}
        openLinkInNewTab={openLinkInNewTab || false}
        className={classes}
        {...rest}
      >
        {content}
      </UniversalLink>
    );
  }

  return (
    <button className={classes} type={type} {...rest}>
      {content}
    </button>
  );
};

export default Button;
